module.exports = __webpack_public_path__ + "img/project-details-2.d2d53266.jpg";